export default __webpack_public_path__ + "static/media/78792.d0078239.jpg";